import PropTypes from 'prop-types';
import { initializeUiBuilder } from './initializeUiBuilder';
import { JQueryWrapper } from '../JQueryWrapper';

/**
 * @param {object} props
 * @param {Library} props.library
 * @returns {JSX.Element}
 */
export const UiBuilder = ({ library }) => {
  return JQueryWrapper({ executeJQueryLogic: navigate => initializeUiBuilder(library, navigate) });
};

UiBuilder.propTypes = {
  library: PropTypes.object,
};
